<div class="street-light-planner-step3">
  <p class="label question">{{ 'module.energyMap.streetlightPlanner.step3PriorityQuestionText' | translate }}</p>
  <div class="choices">
    <mat-radio-group class="radio-group" (change)="onCheckChange($event.value)" [value]="choices[0]">
      <mat-radio-button *ngFor="let item of choices; let i; trackBy: trackByFn" [value]="item">
        {{ item.type }}
      </mat-radio-button>
    </mat-radio-group>
    <div>
      <div class="tooltip-icon" *ngFor="let item of choices; let i; trackBy: trackByFn">
        <app-custom-tooltip
          placement="right"
          [html]="item.tooltip.html"
          [isShown]="item.tooltip.isVisible"
          (tooltipClick)="onTooltipClick(item)"
        ></app-custom-tooltip>
      </div>
    </div>
  </div>
</div>
